// extracted by mini-css-extract-plugin
export default {"wrapper":"Reason_wrapper__DycnI","text":"Reason_text__Ts+-r","item":"Reason_item__ZBT8+"};